import {SingleProduct} from "../../interfaces/product-interface";
import styles from "../../pages/product/product.module.scss";
import React from "react";
import {useTranslation} from "next-i18next";

export default function ProductDetails(props: { product: SingleProduct }) {

    const {t} = useTranslation('common');

    return (
        <div className={styles["products-infos"]}>
            <p className={styles["title"]}>{t('PRODUCT_INFORMATION')}</p>
            <div className={styles["pinfos"]}>
                <div className={styles["pinfo"]}>
                    <p className={styles["plabel"]}>{t('ORL_INFO_PORTRAIT')}</p>
                    <p className={styles["pvalue"]}
                       dangerouslySetInnerHTML={{__html: props.product.custom['portrait']}}/>
                </div>
                <div className={styles["pinfo"]}>
                    <p className={styles["plabel"]}>{t('ORL_INFO_COMPOSITION')}</p>
                    <p className={styles["pvalue"]}
                       dangerouslySetInnerHTML={{__html: props.product.custom['compo']}}/>
                </div>
            </div>
        </div>
    );
}
